import { createComponent } from '@carvana/merch-components';

export const PriceWrapper = createComponent('div', {
  className: 'flex flex-wrap items-baseline gap-x-md'
});

export const StyledPrice = createComponent('span', {
  className: 'text-text-strong t-heading-lg lg:t-heading-2xl'
});

export const OriginalPrice = createComponent('span', {
  className: 'text-text-default t-body-sm'
});
